import { connect } from 'react-redux'

import * as authActions from '../../store/core/authentication/actions'

const mapDispatchToProps = {
  startAuthTicker: authActions.doStartGoogleAuthTicker,
}

export default connect(null, mapDispatchToProps)
